module.exports = __webpack_public_path__ + "img/skis.c859246c.png";